import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { BehaviorSubject, from, of } from 'rxjs';
import { filter, first, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private storageReady = new BehaviorSubject(false);

  constructor(private storage: Storage) {
    this.init();
  }

  async init() {
    await this.storage.create();
    this.storageReady.next(true);
  }

  public set(key: string, value: any) {
    return this.storageReady.pipe(
      filter((ready) => ready),
      switchMap((_) => {
        return from(this.storage.set(key, value) || of([]));
      }),
      first()
    );
  }

  public get(key: string) {
    return this.storageReady.pipe(
      filter((ready) => ready),
      switchMap((_) => {
        return from(this.storage.get(key) || of([]));
      }),
      first()
    );
  }

  public remove(key: string) {
    return this.storageReady.pipe(
      filter((ready) => ready),
      switchMap((_) => {
        return from(this.storage.remove(key) || of([]));
      }),
      first()
    );
  }

  public clear() {
    return this.storageReady.pipe(
      filter((ready) => ready),
      switchMap((_) => {
        return from(this.storage.clear() || of([]));
      }),
      first()
    );
  }

  public keys() {
    return this.storageReady.pipe(
      filter((ready) => ready),
      switchMap((_) => {
        return from(this.storage.keys() || of([]));
      }),
      first()
    );
  }

  public length() {
    return this.storageReady.pipe(
      filter((ready) => ready),
      switchMap((_) => {
        return from(this.storage.length() || of([]));
      }),
      first()
    );
  }
}
